import { useContext, useState } from 'react';
import './orgHeader.css';
// import OrgLogin from "../../../components/orgLogin/orgLogin/OrgLogin";
// import OrgForgotPass from "../../../components/orgLogin/orgForgot/OrgForgotPass";
import { Link } from 'react-router-dom';
import OrgHeadDrop from './orgHeadDrop/OrgHeadDrop';
import Logo from '../../../assets/images/trvto-logo.png';
import MenuIcon from '../../../assets/icons/trvto_downArrow.svg';
import UserIcon from '../../../assets/icons/trvto_user.svg';
import AddIcon from '../../../assets/icons/trvto_plus.svg';
import { OrgAuthContext } from '../../../context/OrgAuthContext';

export default function OrgHeader({ rolelink = ['', ''], roleText = ['', ''], setAddBo = () => {} }) {
    const [page, setPage] = useState(window.location.pathname.split('/')[2]);
    const [headDrop, setHeadDrop] = useState(false);
    const { isOrgAuthenticated } = useContext(OrgAuthContext);
    const name = localStorage.getItem('orgName');

    function linkClick(text) {
        setPage(text);
    }

    return (
        <div className='orgHeaderHomeDiv hideOnPrint'>
            <div className='logoContainer'>
                <img alt='travel logo' src={Logo} width='120' height='50' />
            </div>
            {/* <div>
        <Link
          to="/org/dashboard"
          className={page === "dashboard" ? "orgHeaderBtnSel" : "orgHeaderBtn"}
          onClick={() => linkClick("dashboard")}
        >
          Dashboard
        </Link>
        <Link
          to="/org/my-pack"
          className={page === "my-pack" ? "orgHeaderBtnSel" : "orgHeaderBtn"}
          onClick={() => linkClick("my-pack")}
        >
          My Packages
        </Link>
        <Link
          to="/org/my-room"
          className={page === "my-room" ? "orgHeaderBtnSel" : "orgHeaderBtn"}
          onClick={() => linkClick("my-room")}
        >
          My Rooms
        </Link>
        <button
          className={more ? "orgHeaderBtn moreDropBtnSel" : "orgHeaderBtn"}
          name="moreDrop"
          type="button"
          onClick={() => setMore(!more)}
        >
          More
        </button>
      </div> */}
            {/* {more && (
                    <div
                        className="overlay"
                        onClick={() => setMore(false)}
                    ></div>
                )}
                {more && <MoreDrop page={page} linkClick={linkClick} />} */}
            <div className='orgTabsEndDiv'>
                {/* <Link
                        className="orgTabsHeading add-btn"
                        to="/org/create/room"
                        onClick={() => linkClick('create-room')}
                    >
                        <img
                            alt="add-icn"
                            src={AddIcon}
                            className="orgHeaderMenuIcon"
                        />
                        Create Room
                    </Link> */}
                {roleText[0] !== '' && (
                    <button
                        className='orgTabsHeading add-btn'
                        onClick={() => {
                            setAddBo(true);
                        }}
                    >
                        <img alt='trvto_add-icn' src={AddIcon} className='orgHeaderMenuIcon' />
                        {roleText[0]}
                    </button>
                )}
                {roleText[1] && (
                    <Link
                        className='orgTabsHeading add-btn'
                        to={rolelink[1]}
                        target='_blank'
                        rel='noopener noreferrer'
                        onClick={() => linkClick('create-package')}
                    >
                        <img alt='trvto_add-icn' src={AddIcon} className='orgHeaderMenuIcon' />
                        {roleText[1]}
                    </Link>
                )}
                {/* <Link className="orgTabsHeading">
                        <img
                            alt="user-icon"
                            src={UserIcon}
                            className="orgHeaderMenuIcon"
                        />
                    </Link> */}
                {isOrgAuthenticated && <div className='divider' />}
                {isOrgAuthenticated && (
                    <button
                        className='orgTabsHeading orgMenu'
                        onClick={() => {
                            setHeadDrop(true);
                        }}
                    >
                        <img alt='trvto_menu-icon' src={UserIcon} width={16} height={16} />
                        <span className='truncate-text'>{name}</span>
                        <img alt='trvto_menu-icon' src={MenuIcon} className='orgHeaderMenuIcon' />
                    </button>
                )}
            </div>
            {headDrop && <div className='overlay' onClick={() => setHeadDrop(false)}></div>}
            {headDrop && <OrgHeadDrop linkClick={linkClick} setHeadDrop={setHeadDrop} />}
            {/* {logButton && (
        <div className="orgLoginHeaderPop">
          {loginSec === "login" ? (
            <OrgLogin setLogButton={setLogButton} setLoginSec={setLoginSec} />
          ) : loginSec === "forgot" ? (
            <OrgForgotPass
              setLogButton={setLogButton}
              setLoginSec={setLoginSec}
            />
          ) : null}
        </div>
      )} */}
        </div>
    );
}
